<template>
    <div class="toast-wrapper">
        <div class="toast-wrapper-inner">
            <transition-group name="toast-list">
                <Toast v-for="toast in toasts" :variant="toast.variant" :key="toast.index">{{toast.text}}</Toast>
            </transition-group>
        </div>
    </div>
</template>
<script>
    import Toast from "../../components/Toast/Toast"
    import {mapActions, mapState} from "vuex";
    export default {
        name: 'ToastWrapper',
        components: {
            Toast
        },
        props: {
            toastlist: {
                type: Array,
                default: function(){return[]}
            }
        },
        data () {
            return {

            }
        },
        computed: {
            ...mapState({
                toasts: state => state.toasts.toasts,
            }),
        },
        mounted(){


        },
        methods: {
            ...mapActions('toasts', [
                '_addToast'
            ]),
            addToast() {
                this._addToast();
            },
        }
    }
</script>
<style src="./ToastWrapper.scss" scoped lang="scss"></style>
